import React, {Component} from 'react';
import {Field} from "formik";
import PhoneInput from 'react-intl-tel-input';
import PropTypes from 'prop-types';
import 'react-intl-tel-input/dist/main.css';
import AppVariables from '../../common/AppVariables';

export default class PhoneNumberInput extends Component{

    static propTypes = {
        name: PropTypes.string ,
        placeholder: PropTypes.string ,
        preferredCountries: PropTypes.array ,
        validationMessage: PropTypes.any,
        inputClassName: PropTypes.string,
        disabled: PropTypes.bool,
        regionKey: PropTypes.string,
        includeRegion: PropTypes.bool,
    };

    static defaultProps = {
        preferredCountries: [ AppVariables.CountryPhoneRegionCode ],
        placeholder: 'Enter phone number',
        validationMessage: 'Enter a valid phone number',
        inputClassName: "form-control",
        includeRegion: false
    };

    constructor(props){
        super(props);

        this.state = {
            isValid: false,
            value: '',
            fullNumber: '',
        };

    }

    isValid(){
        return this.state.isValid;
    }

    getFullNumber(){
        return this.state.fullNumber;
    }

    getValue(){
        return this.state.value;
    }

    render(){

        const { name , placeholder , preferredCountries , validationMessage , inputClassName , disabled } = this.props;

        return <Field name={name}>
            {({ field, form: { values , setFieldTouched , setFieldError , setFieldValue }}) =>
                (<PhoneInput inputClassName={inputClassName}
                             fieldId={name}
                             disabled={disabled}
                             fieldName={name}
                             onlyCountries={preferredCountries}
                             telInputProps={field}
                             value={values[name] || ''}
                             style={{ width: "100%" }}
                             placeholder={placeholder}
                             preferredCountries={preferredCountries}
                             onCountryChange={evt => {
                             }}
                             onPhoneNumberChange={(isValid,value,data,fullNumber) => {

                                 //  set field value
                                 setFieldValue(name, value);

                                 if(this.props.includeRegion){
                                     setFieldValue(this.props.regionKey || `${this.props.name}-region`,data.iso2);
                                 }

                                 if(isValid) {
                                     setFieldTouched(name,true,true);
                                 }
                                 else{
                                     setFieldError(name, validationMessage);
                                 }

                                 this.setState({
                                     isValid,
                                     value,
                                     fullNumber
                                 });

                             }}
                             onPhoneNumberBlur={() => {
                                 setFieldTouched(name,true);
                             }}/>)}

        </Field>
    }

}



// WEBPACK FOOTER //
// ./src/components/PhoneNumberInput/PhoneNumberInput.js